import React, { useEffect } from 'react';
import { FAQ } from '../components/home/FAQ';
import { getFaqs } from '../data/faqs';
import { useTranslation } from '../lib/i18n';
export function FAQPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // FAQPage structured data so the questions and answers are eligible for
  // Google rich results (including the safety questions about carrying people).
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: getFaqs(lang).map(faq => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.a
        }
      }))
    };
    let el = document.head.querySelector<HTMLScriptElement>('script[data-faq-schema="true"]');
    if (!el) {
      el = document.createElement('script');
      el.setAttribute('type', 'application/ld+json');
      el.setAttribute('data-faq-schema', 'true');
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);
    return () => {
      el?.remove();
    };
  }, [lang]);
  return <main className="min-h-screen bg-dark-bg" data-id="element-778" data-mp="3t95i8q3zjb62">
      <section className="border-b-2 border-dark-border bg-dark-surface py-16 md:py-20" data-id="element-779" data-mp="3t7udoo2ptzdw">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-780" data-mp="3ocorrp9bckpt">
          <h1 className="mb-4 text-4xl font-black text-white md:text-5xl" data-id="element-781" data-mp="prx2cbstildz">
            {en ? 'Questions and ' : ru ? 'Вопросы и ' : 'Pitanja i '}
            <span className="text-brand-yellow" data-id="element-782" data-mp="fv23frsmuiz6">
              {en ? 'answers' : ru ? 'ответы' : 'odgovori'}
            </span>
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-gray-400" data-id="element-783" data-mp="auxmy1rq5o8y">
            {en ? 'Warranty, service, delivery and safe use of D-TECH equipment — including what the machines may and may not be used for.' : ru ? 'Гарантия, сервис, доставка и безопасное использование оборудования D-TECH — включая то, для чего машины можно и нельзя применять.' : 'Garancija, servis, isporuka i bezbedna upotreba D-TECH opreme — uključujući i za šta mašine smeju, a za šta ne smeju da se koriste.'}
          </p>
        </div>
      </section>
      <FAQ data-id="element-784" data-mp="1imv5gu8d25vr" />
    </main>;
}